import { render, staticRenderFns } from "./xi.vue?vue&type=template&id=a514ea58&scoped=true&"
import script from "./xi.vue?vue&type=script&lang=js&"
export * from "./xi.vue?vue&type=script&lang=js&"
import style0 from "./xi.vue?vue&type=style&index=0&id=a514ea58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a514ea58",
  null
  
)

export default component.exports